import { WorkspaceApplicantDTO } from './workspace-applicant'

export interface WorkspacePostingDTO {
  id: string
  workspace_id: string
  date_created: Date
  date_modified: Date
  location: string
  primary_software: string
  supplemental_software: string
  backup_file_needed: boolean
  specialties: string[]
  capacity: number
  max_allowed_workspaces: number
  job_types: WorkspacePostingJobTypeDTO[]
  description: string
  status: WorkspacePostingStatusDTO
  applicants: WorkspaceApplicantDTO[]
}

export interface WorkspacePostingAggregationDTO {
  status: WorkspacePostingStatusDTO
  total: string
}

export enum WorkspacePostingJobTypeDTO {
  Prep = 'PREP',
  Review = 'REVIEW',
  Bookkeeping = 'BOOKKEEPING',
}

export enum WorkspacePostingStatusDTO {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Cancelled = 'CANCELLED',
  InReview = 'IN_REVIEW',
}
